import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DateTime } from 'luxon';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { LuxonUtils } from '../../shared/utils/luxon-utils';

@Component({
  selector: 'app-date-time-selector',
  templateUrl: './date-time-selector.component.html',
  styleUrls: ['./date-time-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NzDatePickerModule, FormsModule],
})
export class DateTimeSelectorComponent {
  constructor() {}

  @Input() nzAllowClear = true;
  @Input() disabled = false;

  @Input() time?: DateTime;
  @Output() timeChange: EventEmitter<DateTime | undefined> = new EventEmitter();
  // @Input() shouldAbleToSelectDate!: (d: DateTime) => boolean;

  ngOnInit() {
    this.date = LuxonUtils.toJSDateKeepLocalTime(this.time);
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (propName === 'time') {
        const chng = changes[propName];

        if (chng.previousValue !== chng.currentValue) {
          this.date = LuxonUtils.toJSDateKeepLocalTime(chng.currentValue);
        }
      }
    }
  }

  /*
   * MARK - Ant Date
   */

  antDatePickerMode() {
    return 'date';
  }

  getZoneShortName() {
    return DateTime.local().toFormat('ZZZZ');
  }

  date?: Date;

  // disabledDate = (current: Date) => {
  //   if (HyperJs.isNullOrUndefined(this.shouldAbleToSelectDate)) {
  //     return false;
  //   }

  //   const time = DateTime.fromJSDate(current).setZone(Settings.defaultZone, { keepLocalTime: true });
  //   return HyperJs.not(this.shouldAbleToSelectDate(time));
  // };

  @Output() didSelect: EventEmitter<DateTime> = new EventEmitter();
  onChange(result: Date) {
    if (!result) {
      this.didSelect.emit(undefined);
      this.timeChange.emit(undefined);
      return;
    }
    this.date = result;

    const selectedDate = LuxonUtils.toDateTimeKeepLocalTime(this.date)?.set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0,
    });

    this.didSelect.emit(selectedDate);
    this.timeChange.emit(selectedDate);
  }

  // @Output() didSave: EventEmitter<DateTime> = new EventEmitter<DateTime>();
  // viewDidSave() {
  //   this.popupService.pop();
  //   this.didSave.emit(DateTime.fromJSDate(this.date));
  // }

  // viewDidCancel() {
  //   this.popupService.pop();
  // }
}
